import { render } from "./DailyLimitReached.vue?vue&type=template&id=32dded24&scoped=true"
import script from "./DailyLimitReached.vue?vue&type=script&lang=js"
export * from "./DailyLimitReached.vue?vue&type=script&lang=js"

import "./DailyLimitReached.vue?vue&type=style&index=0&id=32dded24&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32dded24"]])

export default __exports__